import React, { useContext } from 'react';
import { AppContext } from '../main';


// Function to group FAQs by category
const groupByCategory = (faqs) => {
  return faqs.reduce((acc, faqs) => {
    (acc[faqs.category] = acc[faqs.category] || []).push(faqs);
    return acc;
  }, {});
};

const Help = (props) => {
  const {
    handleEditItem
  } = props
  const { appState
  } = useContext(AppContext);
  const {
    faqs = {},
    editMode = false
  } = appState

  if (!faqs?.faqs?.[0]) {
    return null
  }


  const freqInfo = faqs?.faqs?.[0] ? faqs?.faqs : []
  const groupedFAQs = groupByCategory(freqInfo);
  const categories = groupedFAQs && Object.keys(groupedFAQs);

  // console.log('faqssss', freqInfo)





  return (
    <div className="container">

      <div className="row">
        {/* Section Header */}
        <div className="col-lg-6">
          <div className="subtitle mb-3">{faqs?.title}</div>
          <h2 className="mb20">{faqs?.subtitle}</h2>
        </div>

        <div className="clearfix"></div>

        {/* Render FAQs Grouped by Category */}
        {categories?.map((category, index) => (
          <div key={index} className="col-lg-6">
            <h3 className="mt-4">{category}</h3>
            <div className="accordion accordion-flush" id={`accflush-${index}`}>
              {groupedFAQs[category].map((faqs) => (
                <div key={faqs.id} className="accordion-item">
                  <h3 className="accordion-header" id={`flush-h${faqs.id}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-c${faqs.id}`}
                      aria-expanded="false"
                      aria-controls={`flush-c${faqs.id}`}
                    >
                      {faqs.question}
                    </button>
                  </h3>
                  <div
                    id={`flush-c${faqs.id}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`flush-h${faqs.id}`}
                    data-bs-parent={`#accflush-${index}`}
                  >
                    <div className="accordion-body">
                      <p>{faqs.answer}</p>
                    </div>
                  </div>

                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Help;
